import LabradorBreakingNews, { StandaloneBreakingNews, StandaloneBreakingNewsProps } from '@/components/BreakingNews';
import { StandaloneComponent } from '@/types/component';
import { useAppState } from 'lib/hooks/useAppState';
import { cn } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';

const HantStandaloneBreakingNews: StandaloneComponent<StandaloneBreakingNewsProps> = (props) => {
  const [{ badge, type }] = useAppState();

  const isArticle = type === 'article';
  const hasBadge = Boolean(badge);

  const withWings = isArticle && cn('wings-hn-gray-100', 'bg-hn-gray-100', 'relative', 'wings', 'py-3');
  const withMargins = isArticle ? (hasBadge ? '-mt-4 sm:-mt-6' : '-mt-3') : '';

  return <StandaloneBreakingNews {...mergeProps({ options: { className: cn(withMargins, withWings) } }, props)} />;
};

export const standalone = HantStandaloneBreakingNews;

export default LabradorBreakingNews;
